import { useEffect, useState } from "react";
import { HashLink } from "react-router-hash-link";
import { Link, useLocation } from "react-router-dom";
import "./header.scss";

const NAV = [
  { label: "Home", to: "/#home", num: "01" },
  { label: "Specialties", to: "/#specialties", num: "02" },
  { label: "Product", to: "/#product", num: "03" },
  { label: "Contact", to: "/#contact", num: "04" },
];

const Header = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  useEffect(() => {
    if (!isHome) {
      setScrolled(false);
      setHidden(false);
      return undefined;
    }

    const onScroll = () => {
      const hero = document.querySelector(".lp-top");
      const heroHeight = hero ? hero.offsetHeight : 600;
      const y = window.scrollY;
      const atTop = y < 8;
      const pastHero = y >= heroHeight;

      setScrolled(pastHero);
      setHidden(!atTop && !pastHero);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [isHome]);

  const light = !isHome;
  const logo = scrolled
    ? "/assets/figma/logo-scrolled.svg"
    : light
      ? "/assets/figma/logo-dark.svg"
      : "/assets/figma/logo-white.svg";

  return (
    <>
      <header
        className={`mz-nav ${light ? "is-light" : "is-green"}${
          scrolled ? " is-scrolled" : ""
        }${hidden ? " is-hidden" : ""}`}
      >
        <div className="mz-nav__inner">
          <Link to="/" className="mz-nav__logo">
            <img src={logo} alt="Mezada" />
          </Link>
          <nav className="mz-nav__links">
            {NAV.map((item) => (
              <HashLink key={item.label} to={item.to} className="mz-nav__link">
                {item.label}
              </HashLink>
            ))}
          </nav>
          <div className="mz-nav__actions">
            <HashLink to="/#contact" className="mz-nav__cta">
              Start a project
            </HashLink>
            <button
              className="mz-nav__burger"
              aria-label="Open menu"
              onClick={() => setMenuOpen(true)}
            >
              <span />
              <span />
            </button>
          </div>
        </div>
      </header>

      <div
        className={`mz-menu${menuOpen ? " is-open" : ""}`}
        aria-hidden={!menuOpen}
        {...(!menuOpen ? { inert: "" } : {})}
      >
        <div className="mz-menu__top">
          <div className="mz-menu__bar">
            <Link
              to="/"
              onClick={() => setMenuOpen(false)}
              tabIndex={menuOpen ? 0 : -1}
            >
              <img src="/assets/figma/logo-menu.svg" alt="Mezada" />
            </Link>
            <button
              className="mz-menu__close"
              onClick={() => setMenuOpen(false)}
              aria-label="Close menu"
              tabIndex={menuOpen ? 0 : -1}
            >
              ✕
            </button>
          </div>
          <nav className="mz-menu__links">
            {NAV.map((item) => (
              <HashLink
                key={item.label}
                to={item.to}
                className="mz-menu__link"
                onClick={() => setMenuOpen(false)}
                tabIndex={menuOpen ? 0 : -1}
              >
                <span className="num">{item.num}</span>
                <span className="label">{item.label}</span>
              </HashLink>
            ))}
          </nav>
        </div>
        <div className="mz-menu__bottom">
          <HashLink
            to="/#contact"
            className="mz-menu__cta"
            onClick={() => setMenuOpen(false)}
            tabIndex={menuOpen ? 0 : -1}
          >
            Start a project
          </HashLink>
          <a
            className="mz-menu__meta"
            href="mailto:info@mezada.net"
            tabIndex={menuOpen ? 0 : -1}
          >
            info@mezada.net
          </a>
        </div>
      </div>
    </>
  );
};

export default Header;
